import {styled} from '@mui/system';
import theme from '../theme';

// used in nav
export const IconStyle = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100vw',
  svg: {
    color: theme.colors.black,
    height: '45px',
    marginLeft: theme.margin.xs,
    marginRight: theme.margin.xs,
  },
});
